import { useRef } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './ElevateSection.css';

function ElevateSection() {
  const { sectionRef, isVisible } = useIntersectionObserver();

  return (
    <section id="elevate" className="elevate-section" ref={sectionRef}>
      {/* Background image - desktop only */}
      <div 
        className="elevate-background-image"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/45bgleft.png)` }}
      ></div>
      
      <div className="elevate-content">
        <h2 className={isVisible ? 'animate' : ''}>Elevate Your Payments</h2>
        <p className={isVisible ? 'animate' : ''}>
          Earn interesting cashbacks, discounts and offers with each payment you make
        </p>
        <a href="https://app.rskpay.in" target="_blank" rel="noopener noreferrer">
          <div className={`get-app-pill ${isVisible ? 'animate' : ''}`}>
            Get App
          </div>
        </a>
        <div className="elevate-sections-container">
          <div className={`elevate-left-section ${isVisible ? 'animate' : ''}`}>
            <div className="card-title-section">
              <h3>Fast & Secure Payments</h3>
            </div>
            <div className="card-subtitle-section">
              <p className="card-subtitle">Experience lightning-fast transactions with bank-grade security. Your payments are protected with advanced encryption technology ensuring complete safety and peace of mind for every transaction you make.</p>
            </div>
          </div>
          <div className={`elevate-right-section ${isVisible ? 'animate' : ''}`}>
            <div className="card-title-section">
              <h3>Seamless Experience</h3>
            </div>
            <div className="card-subtitle-section">
              <p className="card-subtitle">Enjoy a smooth and intuitive payment experience. From recharges to bill payments, everything is just a tap away with our user-friendly interface designed for maximum convenience.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ElevateSection;
